import { render, staticRenderFns } from "./SignKeyPage.vue?vue&type=template&id=668443e1&scoped=true&"
import script from "./SignKeyPage.vue?vue&type=script&lang=ts&"
export * from "./SignKeyPage.vue?vue&type=script&lang=ts&"
import style0 from "./SignKeyPage.vue?vue&type=style&index=0&id=668443e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668443e1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
